import { lazy } from "react";


function load(code){
    switch (code) {
        case "order-payment/list":
            return lazy(() => import("views/order-payment/list"));
        case "order-payment/editor":
            return lazy(() => import("views/order-payment/editor"));
        default:
            return null;
    }
}
export default load;